// src/configs/msalConfig.js (or wherever this currently lives)
import config from "./config";

export const msalConfig = {
  auth: {
    clientId: config.AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${config.AZURE_TENANT_ID}`,
    redirectUri: config.REDIRECT_URL,
    postLogoutRedirectUri: config.POSTREDIRECT_URL,
    // Prevents MSAL from replaying the exact URL the login was started
    // from after a redirect — reduces open-redirect style risk.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // SECURITY TRADEOFF:
    // - "localStorage" (your current setting) persists across tabs and
    //   browser restarts, but is readable by ANY JS running on the page —
    //   including injected/XSS scripts — for as long as it sits there.
    // - "sessionStorage" is the standard MSAL recommendation for public
    //   SPAs: same XSS exposure while a tab is open, but it's cleared the
    //   moment the tab closes, and isn't shared across tabs.
    // Switch to sessionStorage unless you specifically need cross-tab SSO
    // persistence (in which case, keep localStorage but make sure you have
    // a strong CSP in place to limit XSS blast radius).
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    // Disables native broker auth (Windows Hello / native account picker)
    // unless you've explicitly set this app up for it — keeps the auth
    // surface area smaller and predictable.
    allowNativeBroker: false,
  },
};

export default msalConfig;